import React from "react";
import LegalShell, { LegalBlock } from "../components/LegalShell";

export default function Datenschutz() {
  return (
    <LegalShell
      title="Datenschutz"
      subtitle="Informationen zur Verarbeitung personenbezogener Daten gemäß DSGVO."
    >
      <LegalBlock title="1. Verantwortlicher">
        <p>
          Verantwortlich für die Datenverarbeitung auf dieser Website ist:<br />
          all about artists – Sebastian Lang<br />
          Schöttlestraße 22, 70597 Stuttgart<br />
          Telefon: +49 711 72607514<br />
          E-Mail:{" "}
          <a className="text-[var(--crtr-yellow)] underline underline-offset-2" href="mailto:info@all-about-artists.de">
            info@all-about-artists.de
          </a>
        </p>
      </LegalBlock>

      <LegalBlock title="2. Allgemeiner Umgang mit Daten">
        <p>
          Wir verarbeiten personenbezogene Daten nur, soweit dies zur Bereitstellung einer
          funktionsfähigen Website sowie unserer Inhalte erforderlich ist oder Sie eingewilligt
          haben. Rechtsgrundlagen sind insbesondere Art. 6 Abs. 1 DSGVO.
        </p>
      </LegalBlock>

      <LegalBlock title="3. Hosting & Server-Log-Dateien">
        <p>
          Beim Aufruf der Website werden durch den Hosting-Anbieter automatisch technische
          Informationen (z. B. IP-Adresse, Datum und Uhrzeit des Zugriffs, aufgerufene Seite,
          Browsertyp) in Server-Log-Dateien erfasst. Dies dient dem sicheren und stabilen Betrieb
          der Website (berechtigtes Interesse, Art. 6 Abs. 1 lit. f DSGVO).
        </p>
      </LegalBlock>

      <LegalBlock title="4. Kontaktaufnahme">
        <p>
          Wenn Sie uns per E-Mail oder Telefon kontaktieren, werden Ihre Angaben zur Bearbeitung
          der Anfrage und für mögliche Anschlussfragen gespeichert. Diese Daten geben wir nicht
          ohne Ihre Einwilligung weiter.
        </p>
      </LegalBlock>

      <LegalBlock title="5. Cookies, Tracking & Analyse">
        <p>
          Diese Website setzt keine Cookies und verwendet keine Analyse-, Tracking- oder
          Marketing-Tools. Es werden keine Nutzerprofile erstellt und keine Daten zu Werbezwecken
          verarbeitet.
        </p>
      </LegalBlock>

      <LegalBlock title="6. Schriftarten (lokales Hosting)">
        <p>
          Die auf dieser Website verwendeten Schriftarten sind lokal auf unserem Server
          gespeichert. Beim Aufruf der Website wird keine Verbindung zu Servern von Google
          (Google Fonts) oder anderen Drittanbietern zur Auslieferung von Schriftarten aufgebaut.
        </p>
      </LegalBlock>

      <LegalBlock title="7. Externe Links">
        <p>
          Diese Website enthält Verlinkungen zu externen Diensten (z. B. Instagram, YouTube,
          TikTok, Joyn sowie Shops unserer Partner). Erst beim Anklicken dieser Links verlassen
          Sie unsere Website; ab diesem Zeitpunkt gelten die Datenschutzbestimmungen des
          jeweiligen Anbieters. Beim bloßen Aufruf unserer Website werden keine Inhalte von
          Drittanbietern nachgeladen.
        </p>
        <p>
          Ausnahme: Auf unserer Event-Informationsseite bieten wir eine Kartenansicht von Google
          Maps (Google Ireland Limited) an. Diese wird erst nach Ihrem ausdrücklichen Klick auf
          „Google Maps laden“ eingebunden. Erst dann werden Daten (u. a. Ihre IP-Adresse) an Google
          übertragen. Es gelten die Datenschutzbestimmungen von Google:
          policies.google.com/privacy.
        </p>
      </LegalBlock>

      <LegalBlock title="8. Ihre Rechte">
        <p>
          Sie haben das Recht auf Auskunft, Berichtigung, Löschung, Einschränkung der
          Verarbeitung, Datenübertragbarkeit sowie Widerspruch. Zudem können Sie sich bei einer
          Datenschutz-Aufsichtsbehörde beschweren. Zur Ausübung Ihrer Rechte genügt eine formlose
          Nachricht an die oben genannte E-Mail-Adresse.
        </p>
      </LegalBlock>

      <LegalBlock title="9. SSL-/TLS-Verschlüsselung">
        <p>
          Diese Website nutzt aus Sicherheitsgründen eine SSL-/TLS-Verschlüsselung. Eine
          verschlüsselte Verbindung erkennen Sie an „https://“ in der Adresszeile Ihres Browsers.
        </p>
      </LegalBlock>

      <LegalBlock>
        <p className="text-white/45">
          Hinweis: Diese Datenschutzerklärung ist eine allgemeine Vorlage und ersetzt keine
          Rechtsberatung. Bitte lassen Sie die Angaben vor dem Live-Gang rechtlich prüfen und an
          die tatsächlich eingesetzten Dienste anpassen.
        </p>
      </LegalBlock>
    </LegalShell>
  );
}
